const isDevelopment = process.env.NODE_ENV === "development";
const defaultUrl = isDevelopment ? "http://localhost:3000" : "";

export const API_BASE_URL = process.env.REACT_APP_API_URL || defaultUrl;

/* 
console.log('API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  defaultUrl,
  API_BASE_URL,
}); */

export const API_ENDPOINTS = {
  filters: `${API_BASE_URL}/api/v1/filters`,
  deals: `${API_BASE_URL}/api/v1/deals`,
} as const;

export const REQUEST_CONFIG = {
  timeout: 30000,
  retryAttempts: 3,
  retryDelay: 1000,
} as const;
